import type {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'
import {actionsWorkflowsAppBuilder} from '../config/app-builder'
import {workflowRunsMainQuery} from '../queries/workflow-runs/workflow-runs-query'

export function buildAllWorkflowRunsRoute(appBuilder: DataRouterApplicationBuilder<string>) {
  return appBuilder.createQueryRouteConfig('allWorkflowRunsRoute', {
    path: '/:owner/:repo/actions',
    queries: [workflowRunsMainQuery],
  })
}

export const allWorkflowRunsRoute = buildAllWorkflowRunsRoute(actionsWorkflowsAppBuilder)
